// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trace-runs {
    min-width: 380px;
    max-width: 420px;
    overflow: auto;
}
.trace-run {
    padding: 6px 8px;
    cursor: pointer;
    border-bottom: 1px solid rgba(128,128,128,0.25);
}
.trace-run.active {
    border-left: 3px solid var(--primary-color);
}
.trace-run .state-Error, .trace-run .state-Running {
    font-weight: bold;
}
.trace-lines {
    overflow: auto;
    font-family: monospace;
    font-size: 12px;
    white-space: pre-wrap;
}
.trace-line {
    padding: 1px 4px;
}
.trace-line.type-Error {
    color: var(--warn-color, #d32f2f);
}
.trace-line.type-enter, .trace-line.type-exit, .trace-line.type-step {
    font-weight: bold;
}
.trace-line .ts {
    opacity: 0.6;
    margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/workflowtrace/workflowtrace.settings.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,+CAA+C;AACnD;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iCAAiC;AACrC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".trace-runs {\n    min-width: 380px;\n    max-width: 420px;\n    overflow: auto;\n}\n.trace-run {\n    padding: 6px 8px;\n    cursor: pointer;\n    border-bottom: 1px solid rgba(128,128,128,0.25);\n}\n.trace-run.active {\n    border-left: 3px solid var(--primary-color);\n}\n.trace-run .state-Error, .trace-run .state-Running {\n    font-weight: bold;\n}\n.trace-lines {\n    overflow: auto;\n    font-family: monospace;\n    font-size: 12px;\n    white-space: pre-wrap;\n}\n.trace-line {\n    padding: 1px 4px;\n}\n.trace-line.type-Error {\n    color: var(--warn-color, #d32f2f);\n}\n.trace-line.type-enter, .trace-line.type-exit, .trace-line.type-step {\n    font-weight: bold;\n}\n.trace-line .ts {\n    opacity: 0.6;\n    margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
